"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  /**
   * @param {string} name
   * @return {string}
   */
  get: function get(name) {
    if (!name || !window.document.location.search) {
      return null;
    }

    var _stringWithParams = window.document.location.search.replace(/^\?/, ''),
        _params = _stringWithParams.split('&'),
        result = null,
        i,
        len = _params.length;

    for (i = 0; i < len; i++) {
      if (typeof _params[i] === 'string') {
        var _data = _params[i].split('=');

        if (_data[0] == name) {
          result = _data[1] || null;
          break;
        }
      }
    }

    return result;
  },

  /**
   * GET params
   * @return {boolean}
   */
  hasParams: function hasParams() {
    return !!window.document.location.search.replace(/^\?/, '');
  },

  /**
   * @return {{}}
   */
  getSearchParams: function getSearchParams() {
    var data = {},
        searchString,
        searchParamsSection,
        i,
        len,
        searchParamsData;

    if (window.document.location.search) {
      searchString = window.document.location.search.replace(/^\?/, '').replace(/\&$/, '');
      searchParamsSection = searchString.split('&');
      len = searchParamsSection.length;

      for (i = 0; i < len; i++) {
        searchParamsData = searchParamsSection[i].split('=');
        data[searchParamsData[0]] = searchParamsData[1] || null;
      }
    }

    return data;
  }
};
exports["default"] = _default;